import React from "react"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Button from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Button"
import logo from "../../../../images/gatsby-icon.png"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faXing,
  faTwitter,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons"

const startYear = 2022
const currentYear = new Date().getFullYear()

const Footer = ({ navData }) => {
  return (
    <footer className="bg-secondary">
      {/* Footer Meta-Nav */}
      <section className="text-white ">
        <div className="max-w-screen-xl mx-auto px-8">
          <div className="flex flex-row flex-wrap py-4 -mx-grid">
            <div className="w-full px-grid md:order-last md:text-right md:w-1/2 xl:w-5/12">
              <Link
                className="py-2 hover:underline"
                link="/hilfen/kontakt-materialien"
              >
                Kontakt
              </Link>
              <Link className="py-2 ml-4 hover:underline" link="/impressum">
                Impressum
              </Link>
              <Link className="py-2 ml-4 hover:underline" link="/datenschutz">
                Datenschutz
              </Link>
              <Link
                className="py-2 ml-4 hover:underline"
                link="/"
                onClick={(e) => {
                  e.preventDefault()
                  window.klaro.show(window.klaroConfig)
                }}
              >
                Cookie-Konfiguration
              </Link>
            </div>
            <div className="w-full px-grid mt-4 md:mt-0 md:w-1/2 xl:w-7/12">
              <span>
                © {startYear}
                {currentYear !== startYear ? ` - ${currentYear}` : ""}{" "}
                Verein&nbsp;Kinderhilfe&nbsp;Organtransplantation
                –&nbsp;Sportler&nbsp;für&nbsp;Organspende&nbsp;e.V.&nbsp;(KiO)
              </span>
            </div>
          </div>
        </div>
      </section>
    </footer>
  )
}

export default Footer
